<cs-header>
  <cs-header-title>{{ LL.coach.branding.title() }}</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <!-- Logo -->
    <cs-card>
      <cs-card-content>
        <div class="field-label">{{ LL.coach.branding.logoLabel() }}</div>
        <div class="field-help">{{ LL.coach.branding.logoHelp() }}</div>
        <image-uploader
          class="logo-uploader"
          imageId="coach-branding"
          [image]="logoImage"
          [offerRemoveOption]="true"
          [createMultipleSizes]="false"
          [minImageSize]="logoMinImageSize"
          (updateImage)="onLogoUpdated($event)">
        </image-uploader>
      </cs-card-content>
    </cs-card>

    <!-- Brand name -->
    <cs-card>
      <cs-card-content>
        <div class="field-label">{{ LL.coach.branding.brandNameLabel() }}</div>
        <cs-input
          type="text"
          [(value)]="brandName"
          [placeholder]="LL.coach.branding.brandNamePlaceholder()">
        </cs-input>
      </cs-card-content>
    </cs-card>

    <!-- Accent color -->
    <cs-card>
      <cs-card-content>
        <div class="field-label">{{ LL.coach.branding.accentLabel() }}</div>
        <div class="field-help">{{ LL.coach.branding.accentHelp() }}</div>

        <!-- preset swatches -->
        <div class="preset-row">
          @for (preset of presets; track preset) {
            <button
              type="button"
              class="preset-swatch"
              [class.selected]="accentColorHex.toUpperCase() === preset.toUpperCase()"
              [style.background-color]="preset"
              [attr.aria-label]="preset"
              (click)="selectPreset(preset)">
            </button>
          }
        </div>

        <!-- free-form hex: the placeholder is a hex-color format hint, not translatable prose -->
        <cs-input
          class="hex-input"
          type="text"
          [value]="accentColorHex"
          (valueChange)="onAccentInput($event)"
          [placeholder]="'#RRGGBB' | untranslated">
        </cs-input>

        @if (hasLowContrastWarning) {
          <cs-text-alert
            class="contrast-warning"
            type="warning"
            [message]="LL.coach.branding.contrastWarning()">
          </cs-text-alert>
        }
      </cs-card-content>
    </cs-card>

    <!-- Live preview -->
    @if (previewPalette; as palette) {
      <cs-card>
        <cs-card-content>
          <div class="field-label">{{ LL.coach.branding.previewLabel() }}</div>
          <div class="brand-preview">
            <button
              type="button"
              class="preview-button"
              [style.background-color]="palette.primary"
              [style.color]="palette.onAccent">
              {{ LL.coach.branding.previewButton() }}
            </button>
            <span
              class="preview-link"
              [style.color]="palette.link">
              {{ LL.coach.branding.previewLink() }}
            </span>
          </div>
        </cs-card-content>
      </cs-card>
    }

  </cs-card-list>
</cs-content>

<cs-page-action-buttons>
  @if (hasExistingBranding) {
    <cs-button
      secondary
      medium
      [disabled]="isSaving"
      (click)="resetAsync()"
      [label]="LL.coach.branding.reset()">
    </cs-button>
  }
  <cs-button
    medium
    [disabled]="!canSave"
    (click)="saveAsync()"
    [label]="LL.coach.branding.save()">
  </cs-button>
</cs-page-action-buttons>
